module.exports = __webpack_public_path__ + "img/tj.03866da6.png";